module.exports = __webpack_public_path__ + "static/media/Scene 1.7e880d1d.jpg";